import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { successHandler, errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  UpdateCandidateQualityStatusInput,
  UpdateCandidateQualityStatusOutput,
} from '../candidates.types';

export const updateCandidateQualityStatus = (builder: CandidateBuilder) =>
  builder.mutation<
    UpdateCandidateQualityStatusOutput,
    UpdateCandidateQualityStatusInput
  >({
    query: ({ CandidateId, QualityStatus }) => ({
      url: `/candidates/quality-status/${CandidateId}`,
      method: 'PATCH',
      body: { QualityStatus },
    }),
    transformResponse: (queryResponse: {
      data: UpdateCandidateQualityStatusOutput;
    }) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.UpdateCandidate
          : SuccessMessageEn.UpdateCandidate,
        true
      );
      return queryResponse.data;
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[uploadCandidateInfoAction]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.UpdateCandidateFail
          : ErrorMessageEn.UpdateCandidatesFail,
        error,
        true
      );
      return error.data;
    },
    invalidatesTags: (res, meta, arg) => [
      { type: 'Candidate', Id: arg.CandidateId },
    ],
  });
